module.exports = __webpack_public_path__ + "static/media/result_fail.1506875c.mp3";